@if (formulario) {
  <ng-container [formGroup]="formulario">
    <div class="subgrupo">
      <h2>Sirenas</h2>

      <!-- Sirenas -->
      <div class="mb-3">
        <mat-checkbox formControlName="sirenas">Tiene Sirenas</mat-checkbox>
      </div>

      <!-- Prioridad -->
      <ng-container [formGroup]="configuracion">
        @if (sirenas) {
          <mat-form-field style="margin-bottom: 20px">
            <mat-label> Prioridad de asignación </mat-label>
            <input
              matInput
              formControlName="prioridadSirenas"
              type="number"
            />
            <mat-hint>
              Si hay 2 clientes que comparten el poligono de ubicacion,
              las nuevas sirenas se asignarán al que tenga el valor de
              prioridad mas bajo
            </mat-hint>
          </mat-form-field>
        }
      </ng-container>

      <!-- Cobertura -->
      <ng-container [formGroup]="configuracion">
        @if (sirenas) {
          <mat-form-field style="margin-bottom: 20px">
            <mat-label> Distancia de Cobertura de las Sirenas </mat-label>
            <input
              matInput
              placeholder="100"
              formControlName="distanciaCobertura"
              type="number"
            />
            <mat-hint>En metros</mat-hint>
          </mat-form-field>
        }
      </ng-container>

      <!-- Actualizacion automatica firmware sirenas -->
      <ng-container [formGroup]="configuracion">
        <div>
          @if (sirenas) {
            <mat-checkbox
              formControlName="actualizacionesFirmware"
              style="margin-bottom: 1em"
            >
              Actualización Automática de Firmware de Sirenas
            </mat-checkbox>
          }

          @if (sirenas && actualizaciones) {
            <mat-form-field>
              <mat-label>
                Porcentaje máximo de sirenas que se pueden actualizar
                simultáneamente
              </mat-label>
              <input
                matInput
                placeholder="Entre 1% y 100%"
                formControlName="cronLimiteSirenasPor100"
                type="number"
              />
            </mat-form-field>
            <mat-form-field>
              <mat-label>
                Número (absoluto) máximo de sirenas que se pueden
                actualizar simultáneamente
              </mat-label>
              <input
                matInput
                placeholder="Mínimo 1"
                formControlName="cronLimiteSirenasMax"
                type="number"
              />
            </mat-form-field>
          }
        </div>
      </ng-container>

      <!-- Restriccion de uso de sirenas -->
      <ng-container [formGroup]="configuracion">
        @if (sirenas) {
          <mat-checkbox
            formControlName="restringirUsoSirenas"
            style="margin-bottom: 1em"
          >
            Habilitar restricción de uso de sirenas
          </mat-checkbox>
        }

        <div style="display: flex; flex-direction: row; gap: 1em">
          @if (sirenas && restriccion) {
            <mat-form-field>
              <mat-label>
                Tiempo mínimo entre detonaciones (minutos)
              </mat-label>
              <input
                matInput
                formControlName="tiempoEntreUsoSirenas"
                type="number"
              />
            </mat-form-field>
            <mat-form-field>
              <mat-label> Máximo de detonaciones por día </mat-label>
              <input
                matInput
                formControlName="cantidadMaxSirenasPorDia"
                type="number"
              />
            </mat-form-field>
            <mat-form-field>
              <mat-label> Máximo de detonaciones por mes </mat-label>
              <input
                matInput
                formControlName="cantidadMaxSirenasPorMes"
                type="number"
              />
            </mat-form-field>
          }
        </div>
      </ng-container>

      <!-- Compartir Sirenas -->
      <ng-container [formGroup]="configuracion">
        @if (clientes) {
          <mat-form-field>
            <mat-label>Cliente a Compartir Sirenas</mat-label>
            <mat-select
              multiple
              formControlName="idsClientesACompartirSirenas"
            >
              @for (c of clientes; track $index) {
                <mat-option [value]="c._id">{{ c.nombre }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
      </ng-container>
    </div>

    <!-- Controles RF -->
    @if (mostrarControlesRf) {
    <div class="subgrupo">
      <h2>Controles RF</h2>
      <ng-container [formGroup]="configuracion">
        <!-- Botón 1 -->
        <div class="row-center" style="gap: 8px">
          <section class="layout">
            <div>
              <span> Botón 1 (A): </span>
            </div>
            <div class="grow1">
              <mat-form-field>
                <mat-label>Acción </mat-label>
                <mat-select
                  [value]="boton1"
                  (selectionChange)="updateBoton(1, $event.value)"
                >
                  @for (a of acciones; track a) {
                    <mat-option [value]="a">{{ a }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            @if (boton1 === "Alerta") {
              <div class="grow1">
                <ng-select
                  placeholder="Alerta"
                  formControlName="boton1"
                  appendTo="body"
                >
                  @for (b of botones; track b._id) {
                    <ng-option [value]="b._id"
                      >{{ b.nombre }} ({{ b.variante }})</ng-option
                    >
                  }
                </ng-select>
              </div>
            }
          </section>
        </div>
        <!-- Botón 2 -->
        <div class="row-center" style="gap: 8px">
          <section class="layout">
            <div><span>Botón 2 (B):</span></div>
            <div class="grow1">
              <mat-form-field>
                <mat-label>Acción </mat-label>
                <mat-select
                  [value]="boton2"
                  (selectionChange)="updateBoton(2, $event.value)"
                >
                  @for (a of acciones; track a) {
                    <mat-option [value]="a">{{ a }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            @if (boton2 === "Alerta") {
              <div class="grow1">
                <ng-select
                  placeholder="Alerta"
                  formControlName="boton2"
                  appendTo="body"
                >
                  @for (b of botones; track b._id) {
                    <ng-option [value]="b._id"
                      >{{ b.nombre }} ({{ b.variante }})</ng-option
                    >
                  }
                </ng-select>
              </div>
            }
          </section>
        </div>
        <!-- Botón 3 -->
        <div class="row-center" style="gap: 8px">
          <section class="layout">
            <div><span>Botón 3 (C):</span></div>
            <div class="grow1">
              <mat-form-field>
                <mat-label>Acción </mat-label>
                <mat-select
                  [value]="boton3"
                  (selectionChange)="updateBoton(3, $event.value)"
                >
                  @for (a of acciones; track a) {
                    <mat-option [value]="a">{{ a }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            @if (boton3 === "Alerta") {
              <div class="grow1">
                <ng-select
                  placeholder="Alerta"
                  formControlName="boton3"
                  appendTo="body"
                >
                  @for (b of botones; track b._id) {
                    <ng-option [value]="b._id"
                      >{{ b.nombre }} ({{ b.variante }})</ng-option
                    >
                  }
                </ng-select>
              </div>
            }
          </section>
        </div>
      </ng-container>
    </div>
    }

    <!-- Porticos -->
    <div class="subgrupo">
      <h2>Pórticos</h2>
      <div class="mb-3">
        <mat-checkbox formControlName="porticos">Tiene Porticos</mat-checkbox>
      </div>
    </div>
  </ng-container>
}
